import React, { useMemo } from 'react';
import { TabMenu } from '../../../molecules/TabMenu';
import { Logo } from '../../../molecules/Logo';
import { UserSettings } from '../UserSettings';
import Card from '../../../molecules/Card';
import { useUnreadMessages } from '../../../../store/UnreadMessagesContext';
import { useTranslation } from 'react-i18next';
import { BANDS_TAB_ID, CHAT_TAB_ID, FRIENDS_TAB_ID } from '../../../../constants/MainNavigationTabSpecs';

import './NavPanel.scss';

export function NavPanel({ tabs, activeTab, onClick }) {
    const { t } = useTranslation();
    const { totalUnread, totalGroupUnread, pendingFriendRequests } = useUnreadMessages();

    const tabsWithBadges = useMemo(() => (
        tabs.map((tab) => {
            if (tab.id === CHAT_TAB_ID) {
                const badge = totalUnread > 0 ? totalUnread : null;
                return { ...tab, badge };
            }
            if (tab.id === BANDS_TAB_ID) {
                const badge = totalGroupUnread > 0 ? totalGroupUnread : null;
                return { ...tab, badge };
            }
            if (tab.id === FRIENDS_TAB_ID) {
                const badge = pendingFriendRequests > 0 ? pendingFriendRequests : null;
                return { ...tab, badge, badgeAriaLabelKey: 'navigation.friendRequestsBadge' };
            }
            return tab;
        })
    ), [tabs, totalUnread, totalGroupUnread, pendingFriendRequests]);

    return (
        <div className="navigation-panel">
            <Card
                title={(
                    <div className="navigation-panel__header">
                        <Logo variant="stacked" />
                    </div>
                )}
                body={
                    <TabMenu
                        tabs={tabsWithBadges}
                        activeTab={activeTab}
                        onClick={onClick}
                        orientation="vertical"
                        ariaLabel={t('navigation.primaryAria')}
                    />
                }
                footer={(
                    <div className="navigation-panel__footer">
                        <UserSettings />
                    </div>
                )}
                className="navigation-panel__card"
                bodyClassName="scroll-container"
                allowOverflow
            />
        </div>
    );
}
